module.exports = __webpack_public_path__ + "static/img/swfxgl-bg.e7bc314.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/swfxgl-bg.png
// module id = PXAr
// module chunks = 96